import { computed, ref } from "vue";

// 日付をYYYY-MM-DD形式に変換する関数
const formatDateForDisplay = (date: Date | null): string | null => {
  if (!date) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * 画面ロジックを扱う composable。
 */
export const useDeliveryMoveSearchForm = () => {
  // 今日の日付を取得（初期値用）
  const getTodayDate = (): Date => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  };

  // 受付番号
  const searchConditionReceptionNo = ref<string>("");

  // 受付日（From）
  const searchConditionReceptionDateFrom = ref<Date | null>(null);
  const searchConditionReceptionDateFromDisplay = computed(() =>
    formatDateForDisplay(searchConditionReceptionDateFrom.value)
  );

  // 受付日（To）- 初期値は今日
  const searchConditionReceptionDateTo = ref<Date | null>(getTodayDate());
  const searchConditionReceptionDateToDisplay = computed(() =>
    formatDateForDisplay(searchConditionReceptionDateTo.value)
  );

  // 配達日（From）- 初期値は今日
  const searchConditionDeliveryDateFrom = ref<Date | null>(getTodayDate());
  const searchConditionDeliveryDateFromDisplay = computed(() =>
    formatDateForDisplay(searchConditionDeliveryDateFrom.value)
  );

  // 配達日（To）- 初期値は今日
  const searchConditionDeliveryDateTo = ref<Date | null>(getTodayDate());
  const searchConditionDeliveryDateToDisplay = computed(() =>
    formatDateForDisplay(searchConditionDeliveryDateTo.value)
  );

  // datepickerメニュー状態
  const ReceptionDateFrom = ref(false);
  const ReceptionDateTo = ref(false);
  const DeliveryDateFrom = ref(false);
  const DeliveryDateTo = ref(false);

  // datepicker選択時のハンドラー
  const onReceptionDateFromSelected = () => {
    ReceptionDateFrom.value = false;
  };
  const onReceptionDateToSelected = () => {
    ReceptionDateTo.value = false;
  };
  const onDeliveryDateFromSelected = () => {
    DeliveryDateFrom.value = false;
  };
  const onDeliveryDateToSelected = () => {
    DeliveryDateTo.value = false;
  };

  // クリアボタンのハンドラー
  const clearReceptionDateFrom = () => {
    searchConditionReceptionDateFrom.value = null;
  };
  const clearReceptionDateTo = () => {
    searchConditionReceptionDateTo.value = null;
  };
  const clearDeliveryDateFrom = () => {
    searchConditionDeliveryDateFrom.value = null;
  };
  const clearDeliveryDateTo = () => {
    searchConditionDeliveryDateTo.value = null;
  };

  // 配達ステータス選択
  const statusSelectedItem = ref<string[]>([]);

  // 配達タイプ選択
  const deliveryTypeValues = ref<{ label: string; value: number }>({ label: "", value: 0 });

  return {
    formatDateForDisplay,
    searchConditionReceptionNo,
    searchConditionReceptionDateFrom,
    searchConditionReceptionDateTo,
    searchConditionDeliveryDateFrom,
    searchConditionDeliveryDateTo,
    searchConditionReceptionDateFromDisplay,
    searchConditionReceptionDateToDisplay,
    searchConditionDeliveryDateFromDisplay,
    searchConditionDeliveryDateToDisplay,
    ReceptionDateFrom,
    ReceptionDateTo,
    DeliveryDateFrom,
    DeliveryDateTo,
    onReceptionDateFromSelected,
    onReceptionDateToSelected,
    onDeliveryDateFromSelected,
    onDeliveryDateToSelected,
    clearReceptionDateFrom,
    clearReceptionDateTo,
    clearDeliveryDateFrom,
    clearDeliveryDateTo,
    statusSelectedItem,
    deliveryTypeValues,
  };
};
